import React, { Component } from 'react';
import {v4 as uuidv4} from 'uuid';

import Heading from 'Components/Heading';
import Upload from 'Components/Upload';

import Classnames from 'classnames';

import Preview from 'Icons/rfqSingleMode.png';

import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { ReactComponent as PlusIcon } from 'Icons/plus-theme.svg';
import Input from 'Components/Input/index';
import { toPascalCase } from '../../utils/validate';
import { DEEPAK_PHENOLICS, CARGIL } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

class DocumentsCard extends Component {
    constructor(props) {
        super(props);
        this.rfq = props.rfq;
        this.viewMode = props.viewMode;
        this.state = {
            contractNote: props.rfqDetails.contractNote ? props.rfqDetails.contractNote : '',
            rfqLevelSeekerRemarks: props.rfqDetails.rfqLevelSeekerRemarks || ''
        };
    }
    onChange= (file)=> {
        this.props.uploadDocument(file);
    }
    removeDocument = (index, e)=> {
        e.stopPropagation();
        e.preventDefault();
        this.props.removeDocument(index);
    }
    handleContractNotes = (e) => {
        if (this.props.rfqDetails) {
			  this.setState({ contractNote: e.target.value });
			  this.props.rfqDetails.setContractNote(e.target.value);
        }
    }
    handleSeekerRemarks = (e) => {
        if (this.props.rfqDetails) {
			  this.setState({ rfqLevelSeekerRemarks: e.target.value });
			  this.props.rfqDetails.setRfqLevelSeekerRemarks(e.target.value);
        }
    }
    render() {
        const {documents, submitted} = this.props;
        return (
            <React.Fragment>
                <div className="box-shadow ph-20 pv-20 br-5 ">
                    <div className="flex flex-between flex-middle mb-20 pb-15 border-bottom-light mb-20 col-1">
                        <Heading 
                            text="T & C And Other Documents"
                            mandatory={true}
                            hasError={submitted && !(documents || []).length}
                            errorText={'Please Upload Atleast One Document'}
                        />
                        {!this.viewMode && <Upload onChange={this.onChange} value="Upload File" fileSize={DEEPAK_PHENOLICS.includes(getUser().companyId) ? 40 : 10}>
                            <button className="flex flex-middle flex-center border-theme wt-250 ht-40 bg-white theme-color fBold fs-16 br-20"><PlusIcon className="mr-10"/>Upload New Document</button>
                        </Upload>
                        }
                    </div>
                    <div className={Classnames("flex flex-wrap", {
                        "flex-between": (documents || []).length > 2,
                        "flex-around": (documents || []).length <= 2
                    })}>
                        {
                            documents.map((document, index)=> {
                                return (
                                    <div 
                                        key={uuidv4()} 
                                        className="pr wt-150 mr-50 curP mb-40"  
                                        // href={document.url} 
                                        onClick={()=>this.props.downloadUploadedFile(document.name)}
                                        >
                                        <CloseIcon className="pa t-0 r-0 curP" onClick={this.removeDocument.bind(this, index)}/>
                                        <img src={Preview} alt={document.name} className="wt-150 ht-150"/>
                                        <span className="fSemibold fs-14 header-medium-color">{document.name}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {!(documents && documents.length > 0) &&  <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">Please Add The Documents</div>}
                </div>
                <div className="box-shadow ph-20 pv-20 br-5 mb-20 mt-20">
                    <div className="flex flex-between flex-middle mb-20 pb-15 border-bottom-light mb-20 col-1">
                        <Heading text="Contract Note" />
                    </div>
                    <div className="fBold fs-14 caption-color pl-5 mt-25 mb-20 tCenter">
                        <textarea 
                            className=""
                            style={{ width: '100%',  height: '50px' }}
                            name="Contract Notes"
                            placeholder="Contract Notes"
                            value={this.state.contractNote}
                            onChange={this.handleContractNotes}
                            readOnly={this.viewMode}
                        />
                    </div>
                </div>
                {CARGIL.includes(getUser().companyId) && <div className="box-shadow ph-20 pv-20 br-5 mb-20 mt-20">
                    <div className="flex flex-between flex-middle mb-20 pb-15 border-bottom-light mb-20 col-1">
                        <Heading text="Remarks (Internal)" />
                    </div>
                    <div className="fBold fs-14 caption-color pl-5 mt-25 mb-20 tCenter">
                        {!this.viewMode &&
                            <textarea 
                                className=""
                                style={{ width: '100%',  height: '50px' }}
                                name="Remarks"
                                placeholder="Remarks"
                                value={this.state.rfqLevelSeekerRemarks}
                                onChange={this.handleSeekerRemarks}
                            />
                        }
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}

export default DocumentsCard;
